/* Shared visibility lifecycle for decorative videos. */
(function () {
  'use strict';
  if (window.omjMediaReady) return;
  window.omjMediaReady = true;
  const registered = new Set();
  const visible = new Set();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  function hydrate(video) {
    if (video.dataset.sourcesReady) return;
    let changed = false;
    video.querySelectorAll('source[data-src]').forEach(source => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
      changed = true;
    });
    video.dataset.sourcesReady = 'true';
    if (changed) video.load();
  }
  function sync(video) {
    if (!video.isConnected) {
      observer?.unobserve(video); registered.delete(video); visible.delete(video); video.pause(); return;
    }
    if (document.hidden || reduced.matches || !visible.has(video)) {
      video.pause();
      if (video.matches('[data-ugc-video]')) {
        video.muted = true;
        video.closest('.ugc-media')?.classList.remove('is-unmuted');
      }
      return;
    }
    hydrate(video);
    const play = video.play();
    play?.catch(() => {});
  }
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) visible.add(entry.target); else visible.delete(entry.target);
      sync(entry.target);
    });
  }, {threshold:0.15}) : null;
  function boot(root = document) {
    root.querySelectorAll('video[data-omj-video], video.omj-hero-video').forEach(video => {
      if (registered.has(video)) return;
      registered.add(video);
      video.muted = true;
      video.defaultMuted = true;
      if (observer) observer.observe(video);
      else { video.controls = true; hydrate(video); }
    });
  }
  document.addEventListener('visibilitychange', () => registered.forEach(sync));
  reduced.addEventListener('change', () => registered.forEach(sync));
  document.addEventListener('shopify:section:load', event => boot(event.target));
  document.addEventListener('shopify:section:unload', event => {
    registered.forEach(video => {
      if (event.target.contains(video)) {
        observer?.unobserve(video);video.pause();registered.delete(video);visible.delete(video);
      }
    });
  });
  // Explicit sound interaction can play a video even with reduced motion enabled.
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-ugc-sound]');
    const video = button?.closest('.ugc-media')?.querySelector('video');
    if (video) { hydrate(video);video.play()?.catch(() => {}); }
  });
  boot();
})();
